document.addEventListener("turbolinks:load", function() {
  // Make coreui toggle happy
  $('.sidebar').sidebar();
  $('.aside-menu')['aside-menu']();
});
